<!--
Copyright 2023 Google Inc. All rights reserved.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
-->
// modified for WISPR-lab/data-export-gui
<template>
  <div
    v-if="iconOnly"
    class="pa-4"
    style="cursor: pointer"
    @click="navigateToEvents"
  >
    <v-icon :color="isActive ? 'primary' : ''">mdi-timeline-clock-outline</v-icon>
  </div>

  <div v-else>
    <v-divider class="mb-0"></v-divider>
    <div
      class="pa-4"
      style="cursor: pointer"
      @click="navigateToEvents"
      :class="[
        $vuetify.theme.dark ? 'dark-hover' : 'light-hover',
        isActive ? 'active-view' : ''
      ]"
    >
      <span> <v-icon left :color="isActive ? 'primary' : ''">mdi-timeline-clock-outline</v-icon> Events </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    iconOnly: Boolean,
  },
  computed: {
    isActive() {
      return this.$route.name === 'Events' || this.$route.name === 'DemoEvents'
    }
  },
  methods: {
    navigateToEvents() {
      const target = this.$store.state.demoMode ? '/demo/events' : '/events'
      if (this.$route.path !== target) {
        this.$router.push(target)
      }
    },
  },
}
</script>


